import { HStack, VStack } from '@sgme/ui';
import { FormattedMessage } from 'react-intl';

export function NoSchedule() {
  return (
    <VStack
      flex="expand"
      horizontalAlignment="center"
      verticalAlignment="center"
      className="bg-lvl1 w-100 h-100  pb-16px text-center text-secondary"
    >
      <HStack horizontalAlignment="center" verticalAlignment="center">
        <VStack>
          <i className="icon text-center">date_range</i>
          <h5>
            <FormattedMessage id="targetAccumulator.scheduler.noSchedule.title" />
          </h5>
          <p>
            <FormattedMessage id="targetAccumulator.scheduler.noSchedule.message" />
          </p>
        </VStack>
      </HStack>
    </VStack>
  );
}
